module.exports = __webpack_public_path__ + "static/media/Purpose_12.38dc8d97.png";